import React from 'react';
import { Linking } from 'react-native';
import { ListItem } from '@rneui/themed';
import { useChannelQuery } from '@annunciate/query';
import { useUserUUID } from '@annunciate/core';
export const AccountLinks = () => {
    const { data: channel } = useChannelQuery();
    const uuid = useUserUUID();
    const links = channel && channel?.channel?.settings?.account?.links;
    if (!links || !links.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, links
        .filter((link) => !(link.isAuthRequired && !uuid))
        .map((link) => (React.createElement(ListItem, { key: link.name, onPress: () => Linking.openURL(link.link) },
        React.createElement(ListItem.Content, null,
            React.createElement(ListItem.Subtitle, null, link.name)),
        React.createElement(ListItem.Chevron, { size: 30 }))))));
};
//# sourceMappingURL=AccountLinks.js.map